export type HttpCache = {
    key: string;
    value: any;
    expiry: number;
}[];


export const HttpCacheInitialState: HttpCache = [];